if (!customElements.get('product-card-diamond')) {
  class ProductCardDiamond extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.buttons = this.querySelectorAll('a');
      this.activeButtons = this.querySelector('a.active');
      this.buttons?.forEach(ele => {
        ele?.addEventListener('click', (e) => {
          e.preventDefault();
          if (ele.classList.contains('active')) return
          this.toggleButton(ele);
          this.updateMedia(ele);
          this.updateUrl(ele);
          this.updateInfo(ele);
        });
      });
    }
    toggleButton(button) {
      if (!button.classList.contains('active')) { button.classList.add('active'); } else { return }
      if (this.activeButtons && this.activeButtons.classList.contains('active')) { this.activeButtons.classList.remove('active'); }
      this.activeButtons = button
    }
    updateUrl(button) {
      const cardBlock = button.closest('[data-product-block]');
      const cardQuickBuyLink = cardBlock?.querySelector('[data-button-quick-view]');
      const cardAnhorLink = cardBlock?.querySelectorAll('[data-grid-link]:not([data-button-quick-view])');
      cardAnhorLink?.forEach(ele => {
        ele.href = button.href;
      });
      if (cardQuickBuyLink) {
        cardQuickBuyLink.href = button.dataset.url;
        cardQuickBuyLink.dataset.handle = button.dataset.handle;
      }
    }

    updateInfo(button) {
      const cardBlock = button.closest('[data-product-block]');
      if (!cardBlock) return;

      const cardBlockTitle = cardBlock.querySelector('.product-grid-item__title');
      const cardBlockPrice = cardBlock.querySelector('.product-grid-item__price');

      const cardBlockId = cardBlock.dataset?.productId;
      const id = button.dataset?.id;
      const title = button.dataset?.title;
      const price = button.dataset?.price;

      if (price && cardBlockPrice) {
        cardBlockPrice.textContent = 'from ' + price;
      }

      if (id && cardBlockId) {
        cardBlock.dataset.productId = id;
      }

      if (title && cardBlockTitle) {
        cardBlockTitle.textContent = title;
      }
    }


    updateMedia(button) {
      const image = button.dataset.image;
      const image2 = button.dataset.hover;

      if (!image || image === '') return;

      const cardBlock = button.closest('[data-product-block]');
      const cardFeaturedMedia = cardBlock.querySelector('[data-product-media-featured] > div');
      const cardHoverMedia = cardBlock.querySelector('[data-load-hovers] > div');

      if (cardFeaturedMedia) {
        cardFeaturedMedia.style.backgroundImage = `url(${image})`;
      }

      if (cardHoverMedia && image2) {
        cardHoverMedia.style.backgroundImage = `url(${image2})`;
      }

    }
  }

  customElements.define('product-card-diamond', ProductCardDiamond);
}
